export function applyGeneralPreferences(draft, action) {
    const { data } = action.payload;
    draft.workspaces[draft.workspace.current] = data;
}
